export default __webpack_public_path__ + "static/media/Marcha-Basta-de-violencia-Outra-Mare-e-possivel.4ccf8d78.jpg";